export default __webpack_public_path__ + "static/media/refresh-icon.31541675.svg";